__turbopack_context__.v({
  "disclaimer": "a-xAdG_disclaimer",
  "formContainer": "a-xAdG_formContainer",
  "input": "a-xAdG_input",
  "messageContainer": "a-xAdG_messageContainer",
  "select": "a-xAdG_select",
  "submitButton": "a-xAdG_submitButton",
  "textContainer": "a-xAdG_textContainer",
  "wrapper": "a-xAdG_wrapper",
});
